<template>
  <button
    class="bg-white border-0"
    :class="{ 'text-primary': !refreshing, 'text-secondary': refreshing }"
    @click="refresh"
    :disabled="refreshing"
  >
    <i class="fas fa-sync"></i>
    <span v-if="!refreshing">
      Odśwież
    </span>
    <span v-else>
      Wczytuję...
    </span>
  </button>
</template>

<script>
import emitter from '@/modules/events/emitter'

export default {
  name: 'RefreshButton',
  props: ['refreshing'],
  methods: {
    refresh () {
      emitter.emit('refreshed')
    }
  }
}
</script>
